import { createCurrentModule, createInjectableSelector } from '@beef/redux-current';
export var selectCrudeMappingContext = createInjectableSelector();
export var selectCrudeMappingState = createInjectableSelector();
export var CrudeMappingModule = createCurrentModule({
  context: selectCrudeMappingContext,
  state: selectCrudeMappingState
});